import { useState } from "react";
import styled from "styled-components";
import { SidebarAdmin, SubscriptionWarning } from "../components";
import AppHeader from "../components/Shell/AppHeader";
import { useUser } from "../hooks";
import BirthdayCelebration from "../components/Common/BirthdayCelebration";
import { OnboardingTourHost } from "../components/Common/OnboardingTour";
import { sideBarMemberData } from "../utils";
import { InvestorContentFrame } from "../components/Investor/layout/InvestorLayoutPrimitives";

export default function MemberLayout({ children, LayoutClassName }) {
  const [hideSider, setHideSider] = useState(false);
  const user = useUser();
  return (
    <SideBarStyle>
      <BirthdayCelebration />
      <SidebarAdmin
        hideSider={hideSider}
        setHideSider={setHideSider}
        sideBarData={sideBarMemberData}
      />

      <main
        id="main"
        className={`main ${LayoutClassName ? LayoutClassName : `bg-gary2`}`}
      >
        <div className="w-100">
          <AppHeader
            guard="member"
            items={sideBarMemberData}
            user={user}
            onMenuClick={() => setHideSider(!hideSider)}
            notificationsPath="/member/notifications"
          />
        </div>

        <InvestorContentFrame className="maincontent">
          <SubscriptionWarning />
          {children}
        </InvestorContentFrame>
      </main>
      <OnboardingTourHost role="member" />
    </SideBarStyle>
  );
}

const SideBarStyle = styled.div`
  .main {
    overflow: hidden;
    min-height: 92vh;
    margin-left: 280px;
  }
  #main {
    transition: all 0.3s;
    min-height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
  @media (max-width: 1199px) {
    #main {
      margin-left: 0;
    }
  }
`;
